import { Button } from "antd";
import styled from "styled-components";

export const StyledIgnoreStockWrapper = styled.div`
    display: flex;
    margin-top: 8px;
    justify-content: flex-end;
`;

export const StyledIgnoreStockButton = styled(Button)`
    background-color: ${(props) => props.theme.additionalTypographyColor};
    touch-action: manipulation;
`;
